import { icons, LucideProps } from "lucide-react";
import CircularButton, { CircularButtonProps } from "../CircularButton";
import { themeColors } from "@/utils/themeColors";
import { strokeWidth } from "@/utils/iconProps";

const BorderedIconBtn = ({
    icon,
    children,
    sx,
    IconProps,
    ...btnProps
}: {
    icon: keyof typeof icons;
    IconProps?: LucideProps;
} & CircularButtonProps) => {
    const IconComponent = icons[icon];

    if (!IconComponent) {
        return null;
    }

    return (
        <CircularButton
            radius="4rem"
            sx={{
                border: `1px solid ${themeColors.neutral1}`,
                backgroundColor: themeColors.neutralWhite,
                ...sx,
            }}
            {...btnProps}>
            <IconComponent strokeWidth={strokeWidth.normal} size="2rem" {...IconProps} />
            {children as React.ReactNode}
        </CircularButton>
    );
};

export default BorderedIconBtn;
